module.exports = __webpack_public_path__ + "static/media/Cloak.aca74729.jpg";